import React, {Component} from 'react';
import createSelector from 'helpers/createSelector';
import { connect } from 'react-redux';
import moment from 'moment';
import classnames from 'classnames';
import './style.css';
import { routeActions } from 'react-router-redux';
import {AdvancedSearchLayout} from 'modules/advancedSearch';
import { toggleAdvancedModal } from 'modules/advancedSearch/actions';
import {Icon} from 'antd';
import _ from 'lodash';
import { logAsync } from 'helpers/elogAsync';

const container = connect(
  createSelector(
    (state) => ({
      generalRecommend: _.get(state, 'subject.generalRecommend'),
      me:_.get(state, 'me')
    })
    ,
    (state) => {
      const {generalRecommend, me} = state;
      const subjectId = me.permission.searchSubject || "56d94161a4308849680000ac"
      return {
        query: {
          subjectId: subjectId,
          startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
        }
      }
    }
  )
);

class Search extends Component {
  handleEnter = (e) => {
    const {dispatch, query} = this.props;
    dispatch(routeActions.push({
      pathname: '/search',
      query: {
        ...query,
        q: this.refs.searchInput.value
      }
    }))
    .then(() => {
      const {register_email} = localStorage;
      logAsync({
        type: 'sPOP-search',
        data: {
          query: {
            ...query,
            q: this.refs.searchInput.value
          },
          user: register_email
        }
      })
    })
  }

  handleKey = (e) => {
    if (e.which == 13) {
      const {dispatch, query} = this.props;
      dispatch(routeActions.push({
        pathname: '/search',
        query: {
          ...query,
          q: e.target.value
        }
      }))
      .then(() => {
        const {register_email} = localStorage;
        logAsync({
          type: 'sPOP-search',
          data: {
            query: {
              ...query,
              q: this.refs.searchInput.value
            },
            user: register_email
          }
        })
      })
    }
  }

  handleAdvancedModalState = () => {
    const {dispatch} = this.props;
    dispatch(toggleAdvancedModal())
  }

  render() {
    const {afif} = this.props;
    return (
      <div>
        <div className="header-search">
          <input ref="searchInput" type="text" onKeyDown={(e) => this.handleKey(e)}/>
          <button onClick={(e) => this.handleEnter(e)}><Icon style={{ fontSize: '17px', fontWeight: '700' }} type="search" /></button>
        </div>
        <div className={classnames("advance-div",{"advance-display": afif})}>
          <span className="advance-span" onClick={this.handleAdvancedModalState}>進階搜索</span>
        </div>
      </div>

    )
  }
}

export default container(Search)



/** WEBPACK FOOTER **
 ** ./src/app/modules/header/components/Search.js
 **/